import { render, staticRenderFns } from "./jitsiDetail.vue?vue&type=template&id=579ec5b0&"
import script from "./jitsiDetail.vue?vue&type=script&lang=js&"
export * from "./jitsiDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports